/**
 * Rewards Section JS
 * Migrated from old Kiokii theme (old_kiokii/) — April 2026
 * Handles: FAQ accordion, product slider, scroll indicator
 */
document.addEventListener('DOMContentLoaded', function() {
  const rewardsContainer = document.querySelector('.rewards-container');
  if (!rewardsContainer) return;

  // FAQ Section Functionality
  const faqItems = rewardsContainer.querySelectorAll('.faq-item');

  faqItems.forEach(item => {
    const question = item.querySelector('.faq-question');
    const answer = item.querySelector('.faq-answer');

    question.addEventListener('click', () => {
      const isExpanded = question.getAttribute('aria-expanded') === 'true';

      // Close all other items
      faqItems.forEach(otherItem => {
        if (otherItem !== item) {
          otherItem.querySelector('.faq-question').setAttribute('aria-expanded', 'false');
          otherItem.querySelector('.faq-answer').classList.remove('active');
        }
      });

      // Toggle current item
      question.setAttribute('aria-expanded', !isExpanded);
      answer.classList.toggle('active');
    });
  });

  // Featured Products Slider
  const slider = rewardsContainer.querySelector('.featured-products-slider');
  const prevButton = rewardsContainer.querySelector('.slider-prev');
  const nextButton = rewardsContainer.querySelector('.slider-next');

  if (!slider || !prevButton || !nextButton) return;

  let currentPosition = 0;
  let wasMobile = window.innerWidth <= 768;
  let resizeTimeout;
  let touchStartX = 0;
  let touchEndX = 0;
  let isDragging = false;

  function isMobileViewport() {
    return window.innerWidth <= 768;
  }

  function getDesktopMetrics() {
    const firstCard = slider.querySelector('.product-card');
    const container = slider.parentElement;

    if (!firstCard || !container) {
      return {
        stepWidth: 0,
        maxPosition: 0
      };
    }

    const cardStyles = window.getComputedStyle(firstCard);
    const stepWidth = firstCard.getBoundingClientRect().width
      + (parseFloat(cardStyles.marginLeft) || 0)
      + (parseFloat(cardStyles.marginRight) || 0);

    return {
      stepWidth,
      maxPosition: Math.min(0, container.clientWidth - slider.scrollWidth)
    };
  }

  function updateScrollIndicator() {
    const scrollIndicator = slider.querySelector('.scroll-indicator');
    const scrollThumb = slider.querySelector('.scroll-indicator-thumb');

    if (!scrollIndicator || !scrollThumb) return;

    if (!isMobileViewport()) {
      scrollIndicator.style.display = 'none';
      return;
    }

    const scrollableWidth = slider.scrollWidth - slider.clientWidth;

    if (scrollableWidth <= 0) {
      scrollIndicator.style.display = 'none';
      scrollThumb.style.left = '0%';
      return;
    }

    scrollIndicator.style.display = '';

    const visiblePortion = slider.clientWidth / slider.scrollWidth;
    const thumbWidth = Math.max(20, Math.min(80, visiblePortion * 100));
    scrollThumb.style.width = `${thumbWidth}%`;

    const progress = slider.scrollLeft / scrollableWidth;
    const position = progress * (100 - thumbWidth);
    scrollThumb.style.left = `${position}%`;
  }

  function updateSliderPosition() {
    const { maxPosition } = getDesktopMetrics();
    const isMobile = isMobileViewport();

    if (!isMobile) {
      currentPosition = Math.min(0, Math.max(currentPosition, maxPosition));
      slider.style.transform = `translateX(${currentPosition}px)`;
    } else {
      slider.style.transform = '';
    }

    const prevDisabled = isMobile || currentPosition === 0;
    const nextDisabled = isMobile || currentPosition <= maxPosition;

    prevButton.style.opacity = prevDisabled ? '0.5' : '1';
    prevButton.style.pointerEvents = prevDisabled ? 'none' : 'auto';
    prevButton.setAttribute('aria-disabled', prevDisabled ? 'true' : 'false');

    nextButton.style.opacity = nextDisabled ? '0.5' : '1';
    nextButton.style.pointerEvents = nextDisabled ? 'none' : 'auto';
    nextButton.setAttribute('aria-disabled', nextDisabled ? 'true' : 'false');

    updateScrollIndicator();
  }

  function slideNext() {
    if (isMobileViewport()) return;

    const { stepWidth, maxPosition } = getDesktopMetrics();

    if (currentPosition > maxPosition) {
      currentPosition = Math.max(currentPosition - stepWidth, maxPosition);
      updateSliderPosition();
    }
  }

  function slidePrev() {
    if (isMobileViewport()) return;

    const { stepWidth } = getDesktopMetrics();

    if (currentPosition < 0) {
      currentPosition = Math.min(currentPosition + stepWidth, 0);
      updateSliderPosition();
    }
  }

  prevButton.addEventListener('click', slidePrev);
  nextButton.addEventListener('click', slideNext);

  slider.addEventListener('touchstart', (e) => {
    if (isMobileViewport()) return;

    touchStartX = e.touches[0].clientX;
    touchEndX = touchStartX;
    isDragging = true;
  }, { passive: true });

  slider.addEventListener('touchmove', (e) => {
    if (!isDragging || isMobileViewport()) return;

    touchEndX = e.touches[0].clientX;
    const diff = touchStartX - touchEndX;
    const tempPosition = currentPosition - diff;
    const { maxPosition } = getDesktopMetrics();

    if (tempPosition <= 0 && tempPosition >= maxPosition) {
      slider.style.transform = `translateX(${tempPosition}px)`;
    }
  }, { passive: true });

  slider.addEventListener('touchend', () => {
    if (!isDragging) return;

    isDragging = false;

    if (isMobileViewport()) return;

    const diff = touchStartX - touchEndX;
    const threshold = 50;

    if (Math.abs(diff) > threshold) {
      if (diff > 0) {
        slideNext();
      } else {
        slidePrev();
      }
    } else {
      updateSliderPosition();
    }
  });

  slider.addEventListener('scroll', () => {
    if (isMobileViewport()) {
      updateScrollIndicator();
    }
  }, { passive: true });

  function syncSliderMode() {
    const isMobile = isMobileViewport();

    if (isMobile !== wasMobile) {
      currentPosition = 0;
      slider.style.transform = '';
      slider.scrollLeft = 0;
      wasMobile = isMobile;
    }

    updateSliderPosition();
  }

  // Initialize slider
  syncSliderMode();
  window.addEventListener('load', updateScrollIndicator, { once: true });

  // Recalculate on window resize
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      syncSliderMode();
    }, 250);
  });
});
